import { MoreVert } from "@mui/icons-material"
import React, { ReactElement } from "react"
import styled from "styled-components"
import { theme } from "../../../theme"
import { Button, ButtonVariant } from "../../atoms/button"
import { ActionButtonWithMenu, MenuOption } from "./ActionButtonWithMenu"

type ActionButton = {
  label: string
  onClick: () => void
  icon?: ReactElement
  menuOptions?: MenuOption[]
}

export type ButtonGroupProps = {
  primaryActions: ActionButton[]
  secondaryActions: ActionButton[]
  moreMenuOptions?: MenuOption[]
  leftAligned?: boolean
  className?: string
}

export const ButtonGroup = (props: ButtonGroupProps) => {
  const { primaryActions, secondaryActions, moreMenuOptions, leftAligned = false, className } = props

  const renderActionButton = (action: ActionButton, variant: ButtonVariant) => {
    if (!!action.menuOptions) {
      return (
        <ActionButtonWithMenu
          key={action.label}
          label={action.label}
          variant={variant}
          icon={action.icon}
          menuOptions={action.menuOptions}
        />
      )
    }

    return (
      <Button key={action.label} variant={variant} onClick={action.onClick} icon={action.icon}>
        {action.label}
      </Button>
    )
  }

  return (
    <Root className={className} $leftAligned={leftAligned}>
      {secondaryActions.map((action) => renderActionButton(action, ButtonVariant.outlined))}
      {primaryActions.map((action) => renderActionButton(action, ButtonVariant.primary))}
      {!!moreMenuOptions && (
        <ActionButtonWithMenu variant={ButtonVariant.text} icon={<MoreVert />} menuOptions={moreMenuOptions} />
      )}
    </Root>
  )
}

const Root = styled.div<{ $leftAligned: boolean }>`
  width: 100%;
  display: flex;
  justify-content: ${(p) => (p.$leftAligned ? "start" : "end")};
  align-items: center;
  gap: ${theme.spacing.m};
  flex-wrap: wrap;
`
